function dataReducer (state = null, action) {
  return state
}

export default dataReducer



// WEBPACK FOOTER //
// ./src/shared/reducers/data.js